// src/components/Galeria.js
import React from 'react';
import './Galeria.css';

const Galeria = () => {
  const imagens = [
    { src: '/assets/image/mirante.jpg', alt: 'Entrevista na difusora' },
    { src: '/assets/image/cavalo.jpg', alt: 'Fazenda piloto' },
    { src: '/assets/image/fazenda.jpg', alt: 'Boi' }
  ];

  return (
    <section id="galeria" className="section galeria">
      <div className="container">
        <span className="section-eyebrow">Bastidores</span>
        <h2 className="section-title">Nossa Galeria</h2>
        <p className="section-subtitle">Conheça mais sobre nosso trabalho através de imagens que mostram a aplicação da nossa solução no campo.</p>

        <div className="galeria-container">
          {imagens.map((imagem, index) => (
            <div key={index} className="galeria-item">
              <img src={imagem.src} alt={imagem.alt} className="galeria-img" />
              <div className="galeria-overlay">
                <span>{imagem.alt}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Galeria;